import { render, staticRenderFns } from "./Wp_card_sku.vue?vue&type=template&id=6d83f844&scoped=true&"
import script from "./Wp_card_sku.vue?vue&type=script&lang=js&"
export * from "./Wp_card_sku.vue?vue&type=script&lang=js&"
import style0 from "./Wp_card_sku.vue?vue&type=style&index=0&id=6d83f844&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d83f844",
  null
  
)

export default component.exports